import React from "react";
import { arrayOf, bool, func } from "prop-types";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col, Row } from "react-bootstrap";
import * as i18nUtils from "util/i18n";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Credential from "pages/_components/fields/credentials/Credential";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";

const FORM_ID = "login.step2";
const SlideVincularToken = ({ slideIsVisible, closeSlide, isMobile, devices, reemplazarDispositivo, setFormRef }) => {
    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            password: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                password: Yup.string().required(i18nUtils.get("preferences.password.password.incorrect")),
            }),
        onSubmit: (event) => {
            const { password } = event;
            reemplazarDispositivo(password);
        },
    };
    return (
        <Drawer openSidebar={slideIsVisible} toggleSidebar={closeSlide}>
            <div className="container full-width">
                <h1 className="title-content text-center">
                    <CustomText text="Vincular Token" />
                </h1>
                <Row>
                    <Col xs={12} md={10} mdOffset={1}>
                        <Row className="container--alert" role="alert">
                            <Col className="alert alert-warning mt-8">                            
                                <CustomData
                                    icon="alert.svg"
                                    titleText="Actualmente otro dispositivo se encuentra vinculado al Token. ¿Estás seguro que querés vincular este dispositivo?"
                                    keepSpaceIfNoValue={false}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} mdOffset={1} className="box success py-6 px-6 my-8">
                        <Row>
                            <Col xs={4} md={4}>
                                <CustomText text={i18nUtils.get("", "Dispositivo ")} />
                            </Col>
                            <Col xs={8} md={8} className="text-right">
                                <CustomText 
                                    className="font-size-lg font-weight-700" 
                                    text={i18nUtils.get(
                                        "",
                                        devices.length > 0 ? JSON.parse(devices[0].extraInfo)?.shortLabel : "",
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Formik ref={(el) => setFormRef(el)} {...formikValidateProps}>
                    {() => (
                        <Form className="above-the-fold">
                            <Row>
                                <Col xs={12} md={10} mdOffset={1}>
                                    <Field
                                        name="password"
                                        hideLabel={!isMobile}
                                        copyEnabled={false}
                                        component={Credential}
                                        autoFocus
                                        idForm={FORM_ID}
                                    />
                                </Col>
                                <Col xs={12} md={10} mdOffset={1}>
                                    <Button
                                        className="mt-8"
                                        bsStyle="primary"
                                        type="submit"
                                        defaultLabelText="Vincular"
                                        block
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </div>
        </Drawer>
    );
};
SlideVincularToken.propTypes = {
    slideIsVisible: bool.isRequired,
    closeSlide: func.isRequired,
    isMobile: bool.isRequired,
    setFormRef: bool.isRequired,
    devices: arrayOf([]).isRequired,
    reemplazarDispositivo: func,
};

SlideVincularToken.defaultProps = {
    reemplazarDispositivo: () => {},
};

export default SlideVincularToken;
